/**
 * Events API Service
 *
 * Handles all event/calendar-related API calls:
 * - Get events
 * - Add events
 */

import { post } from './client';

export const eventsApi = {
    /**
     * Get all events for a landlord
     * @param {string} landlordId - Landlord ID
     * @returns {Promise<Object>} List of events
     */
    getAll: async (landlordId) => {
        return post('pegasus/visionary/events/', {
            landlord_id: landlordId,
        });
    },

    /**
     * Add a new event
     * @param {Object} eventData
     * @param {string} eventData.landlord_id - Landlord ID
     * @param {string} eventData.title - Event title
     * @param {Date} eventData.start_date - Start date
     * @param {Date} eventData.end_date - End date
     * @returns {Promise<Object>} Add event response
     */
    add: async (eventData) => {
        return post('pegasus/visionary/events/add', eventData);
    },
};

export default eventsApi;
